import { createSlice } from "@reduxjs/toolkit";
import { doDeleteReview, doFetchReviewList } from "./review.action";
import { Meta, Review } from "../config";

interface reviewState {
  reviews: Review[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
}

const initialState: reviewState = {
  reviews: [] as Review[],
  meta: null,
  loading: false,
  error: null,
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch review list
    builder
      .addCase(doFetchReviewList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchReviewList.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchReviewList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // delete review
    builder
      .addCase(doDeleteReview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doDeleteReview.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(doDeleteReview.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default reviewSlice.reducer;
